import useSWR from "swr"

import { WithFailureInfraCmtResponse } from "~/@shared/api-types/InfraCmtResponse"

import { defineFetcher } from "../../api/_common/defineFetcher"
import { GET } from "../../api/_common/http"
import { BadgeReponse, TBadgeStatus } from "./_types"

const PATH = "/student/badge/list"

export const fetchListBadge = defineFetcher(
  (status: TBadgeStatus): Promise<WithFailureInfraCmtResponse<BadgeReponse>> => {
    return GET(`${PATH}?status=${status}`)
  }
)

export const useSWRForGetBadges = (status: TBadgeStatus = "all") => {
  return useSWR([PATH, status], ([url, status]) => fetchListBadge(status))
}
